import {useMemo, useState} from 'react'
import {LinkContainer} from 'react-router-bootstrap'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../common/Icons.jsx'
import {SimpleTable} from '../../../../common/simpleTable/SimpleTable.jsx'
import {createTableListaSprawozdan} from '../columns/tableListaSprawozdan.jsx'
import PropTypes from 'prop-types'
import {useSelector} from 'react-redux'
import {useCzyMoznaInicjowac} from '../../../../../api/domain/sprawozdania/queries/useCzyMoznaInicjowac.jsx'
import {useInicjujSprawozdanie} from '../../../../../api/domain/sprawozdania/mutations/useInicjujSprawozdanie.jsx'
import {ModalHistoriaSprawozdanie} from '../components/modals.jsx'
import {
    ModalProsbaOdblokujSprawozdanie,
    ModalOdblokujSprawozdanie,
    ModalProsbaTymczasoweOdblokujSprawozdanie,
    ModalTymczasoweOdblokujSprawozdanie,
    ModalCofnijTymczasoweOdblokowanieSprawozdanie,
} from '../../../rejestr/lib/components/modals.jsx'
import {groupSprawozdaniaByQuarter} from '../components/groupSprawozdaniaByQuarter.js'
export const ListaSprawozdanProjektu = ({
    rejestrId,
    listaPozycji,
    detailKey,
    setQuery,
    queryBuilder,
    loading,
    exportFileName,
    tytul,
}) => {
    const rola = useSelector((state) => state.user.role)
    const permissions = useSelector((state) => state.user.permissions)
    const canModifyRejestr = Array.isArray(permissions) && permissions.includes('rejestr_modyfikacja')
    const canViewProcess = rola !== 'oper' || (Array.isArray(permissions) && permissions.includes('rejestr_obsluga_podglad'))
    const hasOwnerPermission = Array.isArray(permissions)
        ? permissions.includes('owner')
        : Boolean(permissions?.owner)
    const isWpOwner = rola === 'wp' && hasOwnerPermission
    const [currPozycja, setCurrPozycja] = useState({})
    const [modalState, setModalState] = useState({
        historiaSprawozdanie: false,
        sprawozdanieProsbaOdblokuj: false,
        sprawozdanieOdblokuj: false,
        prosbaTymczasoweOdblokuj: false,
        tymczasoweOdblokuj: false,
        cofnijTymczasoweOdblokuj: false,
    })

    const {data: czyMoznaData, isLoading: czyMoznaLoading} = useCzyMoznaInicjowac(rejestrId)
    const inicjujMutation = useInicjujSprawozdanie()

    const moznaInicjowac = czyMoznaData?.mozna_inicjowac ?? false
    const wOkienku = czyMoznaData?.w_okienku ?? false
    const nastepneOkienkoStart = czyMoznaData?.nastepne_okienko_start ?? null
    const powodBrakuInicjacji = czyMoznaData?.powod ?? 'Nie można zainicjować nowego sprawozdania'

    const czyTymczOdblokowane = listaPozycji?.data?.czy_tymczasowe_odblokowanie_spr === 'Tak'
    const czyProsbaTymczOdblok = listaPozycji?.data?.czy_prosba_tymczasowe_odblokowanie_spr === 'Tak'
    const tymczKwartal = listaPozycji?.data?.tymczasowe_odblokowanie_spr_kwartal
    const tymczRok = listaPozycji?.data?.tymczasowe_odblokowanie_spr_rok
    const uzasadnienieProsbyTymcz = listaPozycji?.data?.uzasadnienie_prosba_tymczasowe_odblokowanie_spr

    const formatujDate = (dateStr) => {
        if (!dateStr) return ''
        return new Date(dateStr).toLocaleDateString('pl-PL', {day: 'numeric', month: 'long', year: 'numeric'})
    }

    const kwartalRzymski = (k) => ['I', 'II', 'III', 'IV'][Number(k) - 1] ?? String(k)

    const kwartalZOkienka = (dateStr) => {
        if (!dateStr) return null
        const d = new Date(dateStr)
        const miesiac = d.getMonth() + 1
        const rok = d.getFullYear()
        const mapa = {1: [4, rok - 1], 4: [1, rok], 7: [2, rok], 10: [3, rok]}
        return mapa[miesiac] ?? null
    }

    const nastepnyKwartalInfo = kwartalZOkienka(nastepneOkienkoStart)

    const tooltipInicjuj = !moznaInicjowac
        ? (!wOkienku && nastepneOkienkoStart
            ? `${powodBrakuInicjacji}. Następne okienko: ${formatujDate(nastepneOkienkoStart)}`
            : powodBrakuInicjacji)
        : undefined

    const lista = useMemo(() => groupSprawozdaniaByQuarter(listaPozycji?.data),
        [listaPozycji?.data]
    )

    const latestSprawozdanieId = useMemo(() => {
        const data = listaPozycji?.data?.list
        if (!Array.isArray(data) || data.length === 0) return null
        return Math.max(...data.map(s => Number(s.id)).filter(id => !isNaN(id) && id > 0))
    }, [listaPozycji?.data])

    const openModal = (type, data) => {
        setCurrPozycja(data)
        setModalState((prev) => ({...prev, [type]: true}))
    }

    const closeModal = (type) =>
        setModalState((prev) => ({...prev, [type]: false}))

    const handleInicjuj = () => {
        inicjujMutation.mutate({rejestr_id: rejestrId})
    }

    const inicjujVariant = moznaInicjowac ? 'primary' : 'secondary'

    const modals = () => (
        <>
            <ModalHistoriaSprawozdanie
                show={modalState.historiaSprawozdanie}
                handleClose={() => closeModal('historiaSprawozdanie')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalProsbaOdblokujSprawozdanie
                show={modalState.sprawozdanieProsbaOdblokuj}
                handleClose={() => closeModal('sprawozdanieProsbaOdblokuj')}
                currPozycja={currPozycja}
            />
            <ModalOdblokujSprawozdanie
                show={modalState.sprawozdanieOdblokuj}
                handleClose={() => closeModal('sprawozdanieOdblokuj')}
                currPozycja={currPozycja}
            />
            <ModalProsbaTymczasoweOdblokujSprawozdanie
                show={modalState.prosbaTymczasoweOdblokuj}
                handleClose={() => closeModal('prosbaTymczasoweOdblokuj')}
                rejestrId={rejestrId}
                tytul={tytul}
            />
            <ModalTymczasoweOdblokujSprawozdanie
                show={modalState.tymczasoweOdblokuj}
                handleClose={() => closeModal('tymczasoweOdblokuj')}
                rejestrId={rejestrId}
                tytul={tytul}
                uzasadnienieProsba={uzasadnienieProsbyTymcz}
                kwartal={tymczKwartal}
                rok={tymczRok}
            />
            <ModalCofnijTymczasoweOdblokowanieSprawozdanie
                show={modalState.cofnijTymczasoweOdblokuj}
                handleClose={() => closeModal('cofnijTymczasoweOdblokuj')}
                rejestrId={rejestrId}
                tytul={tytul}
            />
        </>
    )

    const th = () => {
        return (
            <>
                <th>Akcje</th>
            </>
        )
    }

    const td = (row) => {
        const moznaEdytowac = czyMoznaData?.mozna_edytowac ?? false
        const czyZablokowane = !!row.czy_zablokowane
        const dotyczyAktualnegoKwartalu = Number(row.rok) === czyMoznaData?.aktualny_rok
            && Number(row.kwartal) === czyMoznaData?.aktualny_kwartal
        const allowEdit = (row.status === 'W_EDYCJI' || row.status === 'DO_POPRAWY')
            && moznaEdytowac && !czyZablokowane && dotyczyAktualnegoKwartalu
        const allowView = true
        const isLatest = latestSprawozdanieId !== null && Number(row.id) === latestSprawozdanieId
        const canOdblokParent = ['ZŁOŻONY', 'PRZYJĘTY', 'ZAKOŃCZONY'].includes(row.status)
        const allowProsbaOdblokuj = isWpOwner && canOdblokParent && row.czy_prosba_odblokowanie !== 'Tak' && isLatest
        const allowOdblokuj = rola === 'oper' && canModifyRejestr && canOdblokParent && isLatest && wOkienku
        const rowAsSprawozdanie = {...row, sprawozdanie_id: row.id, sprawozdanie_uzasadnienie_prosba_odblokowanie: row.uzasadnienie_prosba_odblokowanie}

        return (
            <>
                <td className={'pe-4'}>
                    <div className={'d-flex gap-2'}>
                        {allowView && (
                            <LinkContainer
                                to={`/${rola}/sprawozdanie/podglad/${rejestrId}/${row.id}`}
                                state={{ from: `/${rola}/sprawozdanie/lista/${rejestrId}` }}
                            >
                                <ButtonWithIcon
                                    variant={'secondary'}
                                    size={'sm'}
                                    icon={<Icons.eye/>}
                                    title='Podgląd sprawozdania'
                                />
                            </LinkContainer>
                        )}

                        {allowEdit && rola === 'wp' && (
                            <LinkContainer
                                to={`/${rola}/sprawozdanie/edycja/${rejestrId}/${row.id}`}
                                state={{ from: `/${rola}/sprawozdanie/lista/${rejestrId}` }}
                            >
                                <ButtonWithIcon
                                    disabled={loading}
                                    size={'sm'}
                                    icon={<Icons.edit/>}
                                    title='Edytuj sprawozdanie'
                                />
                            </LinkContainer>
                        )}

                        {canViewProcess && (
                            <LinkContainer
                                to={{ pathname: `/${rola}/sprawozdanie/proces/lista/${rejestrId}`, search: `?sprawozdanieId=${row.id}` }}
                            >
                                <ButtonWithIcon
                                    onClick={() => null}
                                    disabled={loading}
                                    size={'sm'}
                                    icon={<Icons.proces/>}
                                    variant={rola === 'oper' ? 'primary' : 'secondary'}
                                    title='Proces sprawozdania'
                                />
                            </LinkContainer>
                        )}

                        <ButtonWithIcon
                            onClick={() =>
                                openModal('historiaSprawozdanie', {
                                    id: rejestrId,
                                    sprawozdanieIds: row?.sprawozdanieIds || [row?.id],
                                    historiaLabel: row?.numer,
                                })
                            }
                            disabled={loading}
                            size={'sm'}
                            icon={<Icons.history/>}
                            variant={'secondary'}
                            title='Historia sprawozdania'
                        />

                        {allowProsbaOdblokuj && (
                            <ButtonWithIcon
                                onClick={() => openModal('sprawozdanieProsbaOdblokuj', rowAsSprawozdanie)}
                                disabled={loading}
                                size={'sm'}
                                icon={<Icons.unlock/>}
                                variant={'warning'}
                                title='Prośba o odblokowanie sprawozdania'
                            />
                        )}

                        {allowOdblokuj && (
                            <ButtonWithIcon
                                onClick={() => openModal('sprawozdanieOdblokuj', rowAsSprawozdanie)}
                                disabled={loading}
                                size={'sm'}
                                icon={<Icons.unlock/>}
                                variant={'warning'}
                                title='Odblokuj sprawozdanie'
                            />
                        )}
                    </div>
                </td>
            </>
        )
    }

    return (
        <>
            {Object.keys(modalState || {}).some((k) => k) && modals()}

            <div className={'d-flex justify-content-between align-items-center mb-3'}>
                <div className={'d-flex gap-2'}>
                    {rola === 'oper' && canModifyRejestr && !czyTymczOdblokowane && (
                        <ButtonWithIcon
                            onClick={() => openModal('tymczasoweOdblokuj', {})}
                            text={czyProsbaTymczOdblok ? 'Obsłuż prośbę o tymczasowe odblokowanie' : 'Tymczasowe odblokowanie'}
                            variant={czyProsbaTymczOdblok ? 'warning' : 'secondary'}
                            icon={<Icons.unlock/>}
                            size={'md'}
                            title='Tymczasowo odblokuj sprawozdawczość'
                        />
                    )}
                    {rola === 'oper' && canModifyRejestr && czyTymczOdblokowane && (
                        <ButtonWithIcon
                            onClick={() => openModal('cofnijTymczasoweOdblokuj', {})}
                            text={'Cofnij tymczasowe odblokowanie'}
                            variant={'danger'}
                            icon={<Icons.lock/>}
                            size={'md'}
                            title='Cofnij tymczasowe odblokowanie sprawozdawczości'
                        />
                    )}
                    {/*{rola === 'wp' && isWpOwner && !wOkienku && !czyTymczOdblokowane && !czyProsbaTymczOdblok && (*/}
                    {/*    <ButtonWithIcon*/}
                    {/*        onClick={() => openModal('prosbaTymczasoweOdblokuj', {})}*/}
                    {/*        text={'Prośba o tymczasowe odblokowanie'}*/}
                    {/*        variant={'secondary'}*/}
                    {/*        icon={<Icons.unlock/>}*/}
                    {/*        size={'md'}*/}
                    {/*        title='Wyślij prośbę o tymczasowe odblokowanie sprawozdawczości'*/}
                    {/*    />*/}
                    {/*)}*/}
                </div>
                <div>
                    {rola !== 'oper' && (
                        <span
                            title={tooltipInicjuj}
                            style={{display: 'inline-block'}}
                        >
                            <ButtonWithIcon
                                onClick={handleInicjuj}
                                disabled={!moznaInicjowac || czyMoznaLoading || inicjujMutation.isPending}
                                text={'Inicjuj nowe sprawozdanie'}
                                variant={inicjujVariant}
                                icon={<Icons.add/>}
                                size={'md'}
                                title={moznaInicjowac ? 'Zainicjuj nowe sprawozdanie' : undefined}
                            />
                        </span>
                    )}
                </div>
            </div>

            {czyTymczOdblokowane && (
                <div className={'alert alert-success d-flex align-items-center gap-2 mb-3'} role={'alert'}>
                    <Icons.unlock />
                    <span>
                        Sprawozdawczość jest tymczasowo odblokowana
                        {tymczKwartal && tymczRok ? ` za ${kwartalRzymski(tymczKwartal)} kw. ${tymczRok}` : ''}.
                        Można inicjować, edytować i składać sprawozdania poza wyznaczonym okresem sprawozdawczym.
                    </span>
                </div>
            )}

            {/*{czyProsbaTymczOdblok && !czyTymczOdblokowane && (*/}
            {/*    <div className={'alert alert-warning d-flex align-items-center gap-2 mb-3'} role={'alert'}>*/}
            {/*        <Icons.info />*/}
            {/*        <span>Oczekiwanie na decyzję Administratora w sprawie prośby o tymczasowe odblokowanie sprawozdawczości.</span>*/}
            {/*    </div>*/}
            {/*)}*/}

            {wOkienku && !czyTymczOdblokowane && (
                <div className={'alert alert-info d-flex align-items-center gap-2 mb-3'} role={'alert'}>
                    <Icons.info />
                    <span>
                        {czyMoznaData?.aktualny_kwartal && czyMoznaData?.aktualny_rok
                            ? `Okres sprawozdawczy za ${kwartalRzymski(czyMoznaData.aktualny_kwartal)} kw. ${czyMoznaData.aktualny_rok} jest otwarty. Aby złożyć sprawozdanie za ${kwartalRzymski(czyMoznaData.aktualny_kwartal)} kw. ${czyMoznaData.aktualny_rok}, należy wybrać opcję "Inicjuj nowe sprawozdanie".`
                            : 'Okres sprawozdawczy jest otwarty. Aby złożyć sprawozdanie, należy wybrać opcję "Inicjuj nowe sprawozdanie".'
                        }
                    </span>
                </div>
            )}

            {!wOkienku && !czyTymczOdblokowane && !czyProsbaTymczOdblok && (
                <div className={'alert alert-warning d-flex align-items-center gap-2 mb-3'} role={'alert'}>
                    <Icons.info />
                    <span>
                        Okres sprawozdawczy jest zamknięty. Nie można edytować ani składać sprawozdań.
                        {nastepneOkienkoStart
                            ? nastepnyKwartalInfo
                                ? ` Okres sprawozdawczy za ${kwartalRzymski(nastepnyKwartalInfo[0])} kw. ${nastepnyKwartalInfo[1]} rozpocznie się ${formatujDate(nastepneOkienkoStart)}.`
                                : ` Następny okres sprawozdawczy: ${formatujDate(nastepneOkienkoStart)}.`
                            : ''
                        }
                    </span>
                </div>
            )}

            <SimpleTable
                exportFileName={exportFileName}
                queryBuilder={queryBuilder}
                setQuery={setQuery}
                detailKey={detailKey}
                columns={createTableListaSprawozdan()}
                addTh={th}
                addTd={td}
                data={lista}
            />
        </>
    )
}

ListaSprawozdanProjektu.propTypes = {
    rejestrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    listaPozycji: PropTypes.object,
    detailKey: PropTypes.string,
    setQuery: PropTypes.func,
    queryBuilder: PropTypes.func,
    loading: PropTypes.bool,
    exportFileName: PropTypes.string,
    tytul: PropTypes.string,
}
